import PrimaryLOGo from "../../Images/1.JPG";
export const AboutInfo = {
  id: "home",
  lightBg: false,
  lightText: true,
  topline: "Android Club Vitap",
  lightTextDesc: true,
  headline: "BEGIN JOURNEY WITH ANDROID CLUB &LEARN EXPERIMENT CREATE",
  description:
    "Android is a mobile operating system based on a modified version of the Linux kernel and other open source software, designed primarily for touchscreen mobile devices such as smartphones and tablets. Android is developed by a consortium of developers known as the Open Handset Alliance and commercially sponsored by Google.",
  imgStart: true,
  img: "https://www.youtube.com/embed/A2r9FCbX9UA?mute=1&playlist=A2r9FCbX9UA",
  alt: "IMAGE",
  dark: true,
  primary: true,
  darkText: false,
  eventSwapper: false,
  dates: "",
  venu: "",
  Linkdisc: "Join Discord",
  eventLinks: "https://discord.gg/X4wHTzk",

  headingcolor: true,
  logos: PrimaryLOGo,
};
